<div class="ui-g card">
  <div class="ui-g-6">
    <h2 class="mt-1 mb-1 sub-header-bar">Customers Using This Checklist</h2>
    <div class="mb-1 instruction">Click to <b>remove</b> this checklist from a customer</div>

    <p-table
      [value]="customersUsing"
      (onRowClick)="removeStepGroup($event)"
      rows="10"
      [paginator]="customersUsing.length > 10"
      rowHover="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Customers Using This Checklist</th>
          <th style="width: 50px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr (click)="removeStepGroup(item)" [pSelectableRow]="item">
          <td>{{ item.name }}</td>
          <td style="width: 50px"><i class="fa fa-arrow-right"></i></td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl [value]="customersUsing" (onRowClick)="removeStepGroup($event)"
                 rows="10"
                 [paginator]="customersUsing.length > 10"
                 rowHover="true">
      <p-column
        filter="true"
        filterPlaceholder="Filter"
        filterMatchMode="contains"
        field="name" header="Customers Using This Checklist" [editable]="false">
        <ng-template let-col let-item="rowData" pTemplate="body">
          {{ item.name }}
        </ng-template>
      </p-column>
      <p-column header="" [editable]="false" [style]="{'text-align':'center', 'width':'60px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <i class="fa fa-arrow-right"></i>
        </ng-template>
      </p-column>
    </p-dataTable>
    --->

    <div class="" *ngIf="customersWereUsing.length > 0">
      <div class="pt-4 pb-2">
        Below is a list of customers who used this checklist template, but have subsequently made
        changes to their checklist. This list is provided for information purposes only; to make the
        same changes for those customers you will need to do so manually
      </div>

      <p-table
        [value]="customersWereUsing"
        rowHover="true"
        rows="10"
        [paginator]="customersWereUsing.length > 10"
        styleClass="noHeader"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.name }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
      <p-dataTabl [value]="customersWereUsing" rowHover="true" rows="10"
                   [paginator]="customersWereUsing.length > 10"
                   styleClass="noHeader">
        <p-column field="name" [editable]="false">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item.name }}
          </ng-template>
        </p-column>
      </p-dataTable>
      --->
    </div>
  </div>
  <div class="ui-g-6">
    <h2 class="mt-1 mb-1 sub-header-bar">Customers Not Using This Checklist</h2>
    <div class="mb-1 instruction">Click to <b>assign</b> this checklist to a customer</div>

    <p-table
      [value]="customersNotUsing"
      rows="10"
      [paginator]="customersNotUsing.length > 10"
      rowHover="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px"></th>
          <th>Customers Not Using This Checklist</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr (click)="applyStepGroup(item)">
          <td style="width: 50px"><i class="fa fa-arrow-left"></i></td>
          <td>{{ item.name }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl [value]="customersNotUsing" (onRowClick)="applyStepGroup($event)"
                 rows="10"
                 [paginator]="customersNotUsing.length > 10"
                 rowHover="true">
      <p-column header="" [editable]="false"
                [style]="{'text-align':'center', 'width':'60px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <i class="fa fa-arrow-left"></i>
        </ng-template>
      </p-column>
      <p-column field="name"
                header="Customers Not Using This Checklist" filter="true" filterPlaceholder="Filter"
                filterMatchMode="contains"
                [editable]="false">
        <ng-template let-col let-item="rowData" pTemplate="body">
          {{ item.name }}
        </ng-template>
      </p-column>
    </p-dataTable>
    -->
  </div>
</div>
